import axiosInstance from "../configuration/request";

export const storePayload = (cartItems,pickupDetails,payloadAddress,selectedService) => {
   let transformed = {};
  const pickupTimeParts = pickupDetails?.pickupTime?.split(" - ") || [];
  const deliveryTimeParts = pickupDetails?.deliveryTime?.split(" - ") || [];

  const commonDetails = {
    pickupDate: pickupDetails?.pickupDate,
    pickupSlot: {
      open: pickupTimeParts[0] || "",
      close: pickupTimeParts[1] || "",
      note: "",
    },
    deliveryDate: pickupDetails?.deliveryDate,
    deliverySlot: {
      open: deliveryTimeParts[0] || "",
      close: deliveryTimeParts[1] || "",
      note: "",
    },
    pickupAddress: {
      id: payloadAddress?.id || "",
      address_line: payloadAddress?.house_no || "",
      city: payloadAddress?.city || "",
      state: payloadAddress?.state || "",
      pincode: payloadAddress?.zipcode || "",
      landmark: payloadAddress?.landmark || "",
      latlong: {
      latitude: Number(payloadAddress?.latlongs[0]?.latitude) || null,
      longitude:  Number(payloadAddress?.latlongs[0]?.longitude) || null,
    }
    },
  };

  if (selectedService === "Wash & Fold") {
    transformed = {
      serviceType: "WASH_N_FOLD",
      items: cartItems.map((item) => ({
        category: item.name,
        quantity: item.weight
      })),
      ...commonDetails
    };
  } else if (selectedService === "Tailoring") {
    transformed = {
      serviceType: "TAILORING",
      items: cartItems.map((item) => ({
        cloth_name :item.name,
        category: item.category,
        tailoringTypes: (item.tailoringType || []).map(type => ({ name: type }))
      })),
      ...commonDetails
    };
  } else {
    transformed = {
      serviceType: "DRYCLEANING",
      items: cartItems.map((item) => ({
        cloth_name:item.name,
        category: item.category,
        quantity: item.weight
      })),
      ...commonDetails
    };
  }
  return transformed
};


export const getServiceEstimate = async (payload, selectedService) => {
  try {
    const res = await axiosInstance.post(
      `/customer/services-offered/estimate`,
      payload
    );

    const rawData = res.data;
    const mappedShops = rawData.map((shop) => {
      const { store, averageRating, totalPrice, matchedItems ,originalPrice  ,pricingTierUsed} = shop;

      // Get today's hours
      const today = new Date().toLocaleDateString("en-US", {
        weekday: "long",
      });
      const todayHours = store?.store_hours?.[today] || null;

      let description = "";
      let services = [];

      if (selectedService === "Tailoring") {
        const tailoringTypes = matchedItems
          .flatMap((item) => item.matches)
          .map((match) => match.tailoringType?.name)
          .filter(Boolean);

        const tailoringDescriptions = matchedItems
          .flatMap((item) => item.matches)
          .map((match) => match.tailoringType?.description)
          .filter(Boolean);

        description =
          tailoringDescriptions.length > 0
            ? tailoringDescriptions[0]
            : "No description available";
        services = tailoringTypes;
      } else {
        description =
          matchedItems.length > 0
            ? matchedItems[0].match.description
            : "No description available";
        services = matchedItems.map((item) => item.match.category);
      }

      // Shop image
      const shopImageDoc = store?.uploadDoc?.find(
        (doc) => doc.name === "shop_image"
      );
      const image = shopImageDoc ? shopImageDoc.fileUrl : null;

      return {
        id: store?.id,
        matchedItems,
        title: store?.storeName,
        totalPrice,
        time: todayHours,
        status: store?.storeStatus ? "Open" : "Closed",
        description,
        services,
        rating: averageRating || 0,
        image,
        isFavorite: false,
        pricingTierUsed: shop?.pricingTierUsed,
        storeAddress: store?.storeAddresses?.[0],
         preferred:store?.preferred,
        originalPrice : originalPrice
      };
    });

    return mappedShops;
  } catch (error) {
    throw error;
  }
};
